import { BasicColorSet, ColorSet } from '@optimus-web/local-tokens';

import { SizeType } from './duplicatedTypes';
import { FontSize, FontWeight, LineHeight } from './enums';

export interface ColorScale {
    readonly base: string;
    readonly 50: string;
    readonly 100: string;
    readonly 200: string;
    readonly 300: string;
    readonly 400: string;
    readonly 700: string;
    readonly 800: string;
    readonly 900: string;
}

export interface BasicColorScale extends ColorScale {
    readonly 25: string;
    readonly 1000: string;
}

export type FontSizes = {
    [key in FontSize]: number;
};

type FontWeightNumbers = 100 | 200 | 300 | 300 | 400 | 500 | 600 | 700 | 800 | 900;
type FontWeightNames = 'lighter' | 'normal' | 'bold' | 'bolder';
type FontWeightValues = FontWeightNumbers | FontWeightNames;

export type FontWeights = {
    [key in FontWeight]: FontWeightValues;
};

export type LineHeights = {
    [key in LineHeight]: number;
};

export interface TextOpacityVariants {
    primary: number;
    secondary: number;
    disabled: number;
}

export interface TypographyTokens {
    fontFamily: string;
    fontSize: FontSizes;
    fontWeight: FontWeights;
    lineHeight: LineHeights;
    textOpacityVariants: TextOpacityVariants;
}

export interface Palette {
    default: BasicColorSet;
    primary: ColorSet;
    error: ColorSet;
    disabled: ColorSet;
    info: ColorSet;
    success: ColorSet;
    warning: ColorSet;
}

export interface Spacing {
    [key: string]: number;
}

export interface Heights {
    small: number;
    medium: number;
    large: number;
}

export interface Size {
    button: {
        heights: Heights;
    };
    input: {
        heights: Heights;
    };
}

export interface ComponentsProps {
    Button: { size: SizeType };
    IconButton: { size: SizeType };
    ListItem: { dense: boolean };
    Checkbox: { small: boolean };
}

export interface Settings {
    rootSize: number;
    componentsProps: ComponentsProps;
}
